import i18n from '@/plugins/languages/i18n'
import Vue from 'vue'

let alerts = new Vue({
  data () {
    return {
      alerts: []
    }
  },

  computed: {
    showAlerts () {
      return this.alerts.length > 0
    }
  },

  methods: {
    closeAlert (index) {
      if (this.showAlerts > 0) {
        this.alerts.splice(index !== null ? index : 0, 1)
      }
    },

    pushAlert (translation, action, status, messageClass = null) {
      setTimeout(this.closeAlert, 9000)
      this.alerts.push({
        messageClass,
        messageText: i18n.t(`${translation}.alerts.${action}.${status}`)
      })
    },

    pushAlertNotTranslated (messageText, messageClass = null) {
      setTimeout(this.closeAlert, 9000)
      this.alerts.push({
        messageClass,
        messageText
      })
    }
  }
})

export default {
  install: (Vue) => {
    Vue.prototype.$alerts = alerts
  }
}
